import React, { Component } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { InsurancePlanDropdownView } from './InsurancePlanDropdownView';

export class InsurancePlanDropdownContainer extends Component {
    static propTypes = {
        carrierId: PropTypes.string.isRequired,
        fetchPlansIfNeeded: PropTypes.func.isRequired,
        isLoading: PropTypes.bool.isRequired,
        onChange: PropTypes.func.isRequired,
        onClick: PropTypes.func,
        planId: PropTypes.string,
        plans: PropTypes.array.isRequired,
    };

    static defaultProps = {
        onClick: noop,
    };

    componentDidMount() {
        this.fetchPlansIfNeeded(this.props);
        this.validateSelectedPlan(this.props);
        this.autoSelectPlan(this.props);
    }

    componentDidUpdate(prevProps) {
        if (this.props.carrierId !== prevProps.carrierId) {
            this.fetchPlansIfNeeded(this.props);
        }

        this.validateSelectedPlan(this.props);
        this.autoSelectPlan(this.props);
    }

    render() {
        const { isLoading, onChange, onClick, planId, plans } = this.props;

        return (
            <InsurancePlanDropdownView
                isLoading={isLoading}
                onChange={onChange}
                onClick={onClick}
                planId={planId}
                plans={plans}
            />
        );
    }

    fetchPlansIfNeeded({ carrierId, fetchPlansIfNeeded }) {
        fetchPlansIfNeeded(carrierId);
    }

    validateSelectedPlan({ onChange, planId, plans }) {
        if (plans.length < 2 || !planId || parseInt(planId, 10) < 0) {
            return;
        }

        if (!plans.find(plan => plan.id === planId)) {
            onChange();
        }
    }

    autoSelectPlan({ onChange, planId, plans }) {
        if (plans.length !== 1) {
            return;
        }

        const availablePlanId = plans[0].id;
        if (availablePlanId !== planId) {
            onChange(availablePlanId);
        }
    }
}
